import React from 'react'
import { useTranslation } from 'react-i18next'

require('./ErrorMessage.scss')

const ErrorMessage = () => {
    const { t } = useTranslation()
    return (
        <div className="ErrorMessage">
            <div className="errorContainer">
                <div className="errorHeader" data-testid="error-header">
                    {t('common:generalError.header')}
                </div>
                <div className="errorSubheader">{t('common:generalError.subheader')}</div>
                <button
                    className="errorCta"
                    onClick={() => {
                        window.location.reload()
                    }}
                >
                    {t('common:generalError.cta')}
                </button>
            </div>
        </div>
    )
}

export default ErrorMessage
